export const STAFF_BASE_PERMISSIONS = {
	FORBIDDEN: 'forbidden',
	ALLOW_VIEW: 'view',
	ALLOW_VIEW_EDIT: 'view_edit',
	ALLOW_VIEW_EDIT_DELETE: 'view_edit_delete',
	ALLOW_VIEW_EDIT_DELETE_MANAGE: 'view_edit_delete_manage'
}

export const STAFF_COMPANY_BASE_PERMISSIONS = {
	FORBIDDEN: 'forbidden',
	VIEW: 'view',
	EDIT: 'edit',
	DELETE: 'delete',
	MANAGE: 'manage',
	OWNER: 'owner',
	OT_STAFF: 'otStaff',
	OT_ADMIN: 'otAdmin',
}

export const STAFF_COMPANY_BASE_PERMISSION_LEVEL = {
	[STAFF_COMPANY_BASE_PERMISSIONS.FORBIDDEN]: 0,
	[STAFF_COMPANY_BASE_PERMISSIONS.VIEW]: 1,
	[STAFF_COMPANY_BASE_PERMISSIONS.EDIT]: 2,
	[STAFF_COMPANY_BASE_PERMISSIONS.DELETE]: 3,
	[STAFF_COMPANY_BASE_PERMISSIONS.MANAGE]: 4,
	[STAFF_COMPANY_BASE_PERMISSIONS.OWNER]: 5,
	[STAFF_COMPANY_BASE_PERMISSIONS.OT_STAFF]: 6,
	[STAFF_COMPANY_BASE_PERMISSIONS.OT_ADMIN]: 7,
}
